import {default as init} from "surveylabJsAssets/chart/charts";
import {setDefaultOptions} from "sdbbJsAssets/chart/charts";

export default function () {
    setDefaultOptions({
        chart: {
            width: 594,
            height: 425,
            spacingTop: 10,
            spacingLeft: 0,
            marginLeft: 215,
            marginRight: 5,
            type: 'columnrange',
            inverted: true,
            plotBorderWidth: 1,
            plotBorderColor: 'black',
            events: undefined,
        },
        xAxis: {
            labels: {
                style: {
                    fontWeight: 'normal'
                }
            }
        },
        yAxis: {
            title: {
                // Text null means title is disabled,
                // enable it by overwriting the text
                text: null,
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                }
            },
            labels: {
                y: 21,
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                }
            },
            gridLineColor: 'black',
            min: 20,
            max: 80,
            tickInterval: 10
        },
        colors: [
            'black',
            '#295f99',
            '#00a833',
            '#bf003f',
            '#434348',
            '#ff7f7f',
            '#994b00',
            '#542f8c',
            '#ffff00',
            '#94afcc',
            '#89c172'
        ]
    });

    init();
}